import { ApiResponseBody, EmployeeLocation, PaginatedApiResponseBody } from '@/api/types';
import { http } from '@/api/http';
import { getHomeLocationApiUrl } from './homelocation.paths';
import { PaginatedHomeLocationListFilters } from './homelocation.types';

const getHomeLocationsList = async (params: PaginatedHomeLocationListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<EmployeeLocation>>(getHomeLocationApiUrl.homeLocations(), {
    params,
  });
  return res.data.data;
};

const getHomeLocation = async (id: string) => {
  const res = await http.get<ApiResponseBody<EmployeeLocation>>(getHomeLocationApiUrl.homeLocationById(id));
  return res.data.data;
};

const addHomeLocation = async (body: Omit<EmployeeLocation, 'id'>) => {
  const res = await http.post<ApiResponseBody<EmployeeLocation>>(getHomeLocationApiUrl.homeLocations(), body);
  return res.data.data;
};

const updateHomeLocation = async ({ id, ...body }: Partial<EmployeeLocation> & { id: string }) => {
  const res = await http.patch<ApiResponseBody<EmployeeLocation>>(getHomeLocationApiUrl.homeLocationById(id), body);
  return res.data.data;
};

export const homeLocationApiFetcher = {
  getHomeLocationsList,
  getHomeLocation,
  addHomeLocation,
  updateHomeLocation,
};
